import React from 'react';
import '../../styles/Hero.css';
import { useLanguage } from '../../contexts/LanguageContext';

const Hero: React.FC = () => {
  const { t } = useLanguage();
  
  return (
    <section id="home" className="hero">
      {/* Animated Background Elements */}
      <div className="hero-bg-animation">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="mining-icon"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 15}s`,
              fontSize: `${20 + Math.random() * 30}px`
            }}
          >
            🚛
          </div>
        ))}
        {[...Array(20)].map((_, i) => (
          <div
            key={`excavator-${i}`}
            className="mining-icon"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 15}s`,
              fontSize: `${15 + Math.random() * 25}px`
            }}
          >
            🏗️
          </div>
        ))}
      </div>

      {/* Content */}
      <div className="hero-content">
        <h1>
          🌟 {t('hero.title.main')} 
          <span>{t('hero.title.highlight')}</span>
          {t('hero.title.subtitle')}
        </h1>
        
        <p>
          {t('hero.description')}
        </p>

        <div className="hero-stats">
          <div className="stat-item">
            <h3>🔄 {t('hero.stat.automatic')}</h3>
            <p>{t('hero.stat.automatic.sub')}</p>
          </div>
          <div className="stat-item">
            <h3>⚡ {t('hero.stat.realtime')}</h3>
            <p>{t('hero.stat.realtime.sub')}</p>
          </div>
          <div className="stat-item">
            <h3>📈 {t('hero.stat.production')}</h3>
            <p>{t('hero.stat.production.sub')}</p>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="scroll-indicator">
        <div className="scroll-line"></div>
        <div className="scroll-text">Scroll Down</div>
      </div>
    </section>
  );
};

export default Hero;